module.exports = __webpack_public_path__ + "assets/notification-blue.5a8c4cd1.svg";